<template>
  <div>
    <transition name="fold">
    <div class="receiptOrder" v-show="show">
      <div class="head">
        <span v-if="receiptOrderForm.receiptId">修改</span>
        <span v-else>新增</span>
        配货单&nbsp;&nbsp;{{receiptOrderForm.areaName}}
        <span style="font-size:20px;float: right;padding: 0 10px;background: #409dfb;font-weight: 500;color: #fff;border-radius: 5px;">应收垫款为{{money}}元，抹掉{{avoid}}元</span>
      </div>
      <div class="content">
        <el-form :model="receiptOrderForm" :rules="receiptOrderRules" ref="receiptOrderForm"  label-width="80px" size="mini">
          <el-form-item label="创建时间" v-if="receiptOrderForm.receiptId">
            <el-col :span="10">
              <el-date-picker
                class="dataPicker"
                v-model="receiptOrderForm.createDate"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="timestamp">
              </el-date-picker>
            </el-col>
            <el-col :span="6">找车人</el-col>
            <el-col :span="8">
              <el-select clearable v-model="receiptOrderForm.createBy" placeholder="找车人">
                <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId">
                </el-option>
                <el-option label="自己上车" :value=2>
                </el-option>
                <el-option label="合车" :value=3></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="实际运费"  >
            <el-col :span="13">
              <el-form-item prop="actualFreight">
                <el-input type="number" ref="freight" :placeholder="'订车运费为' + receiptOrderForm.freight + receiptOrderForm.priceUnit" v-model="receiptOrderForm.actualFreight" auto-complete="off" >
                  <template slot="append">{{receiptOrderForm.priceUnit}}</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="10">
              <el-form-item prop="tonnage">
                <el-input type="number" v-model="receiptOrderForm.tonnage" placeholder="请输入吨位">
                  <template slot="append">吨</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="实际收款" prop="total">
            <el-input type="number" v-model="receiptOrderForm.total" placeholder="一共收多少钱">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="信息费">
            <el-col :span="10">
              <el-form-item prop="cash">
                <el-input type="number" v-model="receiptOrderForm.cash" placeholder="信息费">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1">&nbsp;</el-col>
            <el-col :span="13">
              <el-form-item prop="advances">
                <el-input type="number" v-model="receiptOrderForm.advances" placeholder="垫款">
                  <template slot="append">垫款</template>
                </el-input>
              </el-form-item>
            </el-col>
            <!--<el-col class="line" :span="1">&nbsp;</el-col>-->
            <!--<el-col :span="8">-->
              <!--<el-form-item prop="weixin">-->
                <!--<el-input type="number" v-model="receiptOrderForm.weixin" placeholder="微信">-->
                  <!--<template slot="append">微信</template>-->
                <!--</el-input>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
          </el-form-item>
          <el-form-item label="车牌号码"  prop="carNumber" class="city-autocomplete">
            <el-col :span="19">
              <el-autocomplete
                popper-class="my-autocomplete"
                :fetch-suggestions="queryCar"
                placeholder="请输入车牌号码"
                @select="handleSelectCar"
                v-model="receiptOrderForm.carNumber"
                :trigger-on-focus="false"
                :disabled="carNumberIsEnable"
                @blur="blurCarNumber"
              >
                <template slot-scope="{ item }">
                  <div class="name" v-if="item.count >0"><i style="color: #d53131">{{ item.carNumber }}</i>&nbsp;<i style="color: #b4b4b4">{{ item.name }}&nbsp;{{item.phone}}</i>{{item.title}}</div>
                  <div class="name" v-else>{{ item.carNumber }}&nbsp;<span style="color: #b4b4b4">{{ item.name }}&nbsp;{{item.phone}}</span><i style="color: red;font-weight: 800">{{item.title}}</i></div>
                </template>
              </el-autocomplete>
            </el-col>
            <el-col class="line" :span="1">&nbsp;</el-col>
            <el-col :span="4">
              <el-checkbox label="不明" v-model="carNumberIsEnable" @change="handleCheckCarNumber" class="tabindex" border size="mini" tabindex=-1></el-checkbox>
            </el-col>
          </el-form-item>
          <el-form-item label="车主电话"  prop="ownerPhone" class="city-autocomplete">
            <el-col :span="19">
              <el-autocomplete
                popper-class="my-autocomplete"
                :fetch-suggestions="queryOwner"
                placeholder="请输入车主电话"
                @select="handleSelectOwner"
                v-model="receiptOrderForm.ownerPhone"
                :trigger-on-focus="false"
                :disabled="ownPhoneIsEnable"
                @blur="blurOwnerPhone"
                clearable
              >
                <template slot-scope="{ item }">
                  <div class="name"><i v-if="item.count >0" style="color: #d53131;">{{ item.phone }} {{ item.name }}&nbsp;{{item.title}}</i><span v-else>{{ item.phone }} {{ item.name }}&nbsp;<i style="color: red;font-weight: 800">{{item.title}}</i></span></div>
                </template>
              </el-autocomplete>
            </el-col>
            <el-col class="line" :span="1">&nbsp;</el-col>
            <el-col :span="4">
              <el-checkbox label="不明" v-model="ownPhoneIsEnable" @change="handleCheckOwnPhone" class="tabindex" border size="mini" tabindex=-1></el-checkbox>
            </el-col>
          </el-form-item>
          <el-form-item label="车主姓名" prop="ownerName" >
            <el-col :span="19">
            <el-input :disabled="ownNameIsEnable" placeholder="车主姓名" v-model="receiptOrderForm.ownerName" auto-complete="off" clearable>
            </el-input>
            </el-col>
            <el-col class="line" :span="1">&nbsp;</el-col>
            <el-col :span="4">
              <el-checkbox label="不明" v-model="ownNameIsEnable" @change="handleCheckOwnName" class="tabindex" border size="mini" tabindex=-1></el-checkbox>
            </el-col>
          </el-form-item>
          <el-form-item label="司机电话"  prop="carPhone" class="city-autocomplete">
            <el-col class="line" :span="19">
              <el-autocomplete
                popper-class="my-autocomplete"
                :fetch-suggestions="queryDriver"
                placeholder="请输入司机电话"
                @select="handleSelectDriver"
                v-model="receiptOrderForm.carPhone"
                :trigger-on-focus="false"
                @blur="blurDriverPhone"
                :disabled="driverPhoneIsEnable"
                clearable
              >
                <template slot-scope="{ item }">
                  <div class="name"><i v-if="item.count >0" style="color: #d53131;">{{ item.phone }} {{ item.name }}&nbsp;{{item.title}}</i><span v-else>{{ item.phone }} {{ item.name }}&nbsp;<i style="color: red;font-weight: 800">{{item.title}}</i></span></div>
                </template>
              </el-autocomplete>
            </el-col>
            <el-col class="line" :span="1">&nbsp;</el-col>
            <el-col :span="4">
              <el-checkbox label="不明" v-model="driverPhoneIsEnable" @change="handleCheckDriverPhone" class="tabindex" border size="mini" tabindex=-1></el-checkbox>
            </el-col>
          </el-form-item>
          <el-form-item label="司机姓名" prop="carName" >
            <el-col class="line" :span="19">
              <el-input :disabled="driverNameIsEnable" placeholder="司机姓名" v-model="receiptOrderForm.carName" auto-complete="off" clearable>
              </el-input>
            </el-col>
            <el-col class="line" :span="1">&nbsp;</el-col>
            <el-col :span="4">
              <el-checkbox label="不明" v-model="driverNameIsEnable" @change="handleCheckDriverName" class="tabindex" border size="mini" tabindex=-1></el-checkbox>
            </el-col>
          </el-form-item>
          <el-form-item label="家庭住址" prop="address" >
            <el-input  placeholder="家庭住址" v-model="receiptOrderForm.address" auto-complete="off" >
            </el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="IDCard" >
            <el-input  placeholder="身份证号" v-model="receiptOrderForm.IDCard" auto-complete="off" >
            </el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="receiptOrderForm.remark" placeholder="对此备注的信息"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="foot" style="padding: 0 5px">
          <el-button type="primary" @click="submitForm('receiptOrderForm')" size="mini">提交</el-button>
      </div>
    </div>
    </transition>
    <transition name="fade">
    <div class="list-mask"  @click="hideList('receiptOrderForm')"  v-show="show"></div>
    </transition>
  </div>
</template>

<script>
import { getDriverForPhone, selectDriver, updateDriver } from '../api/driver'
import { getCarForNumber, selectCar } from '../api/car'
import {createReceiptOrder, updateReceiptOrder} from '../api/receiptOrder'

export default {
  props: {
    userList: {
      type: Array,
      default () {
        return [
          {
            userName: '',
            userId: ''
          }
        ]
      }
    },
    fold: {
      type: Boolean,
      default: false
    },
    receiptOrder: {
      default () {
        return {
          appId: '',
          areaCode: '',
          carNumber: '',
          cargoId: '',
          supplyId: '',
          driverPhone: '',
          content: '',
          freight: '',
          orderId: '',
          priceUnit: '',
          remark: null
        }
      }
    }
  },
  data () {
    var validateTotal = (rule, value, callback) => {
      if (this.wei.isNull(value)) {
        return callback(new Error('实际收款不能为空'))
      } else if (this.receiptOrderForm.advances !== '' && this.receiptOrderForm.cash !== '' && this.receiptOrderForm.weixin !== '') {
        let count = this.receiptOrderForm.advances * 1 + this.receiptOrderForm.cash * 1 + this.receiptOrderForm.weixin * 1
        if (count !== (value * 1) && !isNaN(count)) {
          return callback(new Error('实际收款金额输入有误,请检查现金、微信、垫款输入是否有误'))
        }
      }
      if (this.receiptOrderForm.advances !== '' && this.receiptOrderForm.tonnage !== '' && this.receiptOrderForm.actualFreight !== '') {
        if (Math.round(((this.receiptOrderForm.actualFreight * 1 - this.receiptOrderForm.freight * 1) * this.receiptOrderForm.tonnage)) < this.receiptOrderForm.advances * 1 || ((this.receiptOrderForm.actualFreight * 1 - this.receiptOrderForm.freight * 1) * this.receiptOrderForm.tonnage) < 0) {
          return callback(new Error('运费或吨位输入错误'))
        }
      }
      callback()
    }
    var validateMoney = (rule, value, callback) => {
      if (this.wei.isNull(value)) {
        return callback(new Error('金额不能为空'))
      } else if (this.receiptOrderForm.total !== '') {
        this.$refs.receiptOrderForm.validateField('total')
      }
      callback()
    }
    return {
      carNumberIsEnable: false,
      ownNameIsEnable: false,
      ownPhoneIsEnable: false,
      driverPhoneIsEnable: false,
      driverNameIsEnable: false,
      receiptOrderForm: {
        createDate: null,
        freight: '',
        receiptId: '',
        actualFreight: '',
        tonnage: '',
        total: '',
        createBy: null,
        cash: '',
        weixin: 0,
        advances: '',
        ownerId: '',
        driverId: '',
        areaName: '',
        areaCode: '',
        orderId: '',
        carId: '',
        appId: '',
        supplyId: '',
        remark: '',
        isFlagCatego: '',
        priceUnit: '',
        carNumber: '',
        carPhone: '',
        ownerName: '',
        ownerPhone: '',
        address: '',
        IDCard: '',
        carName: ''
      },
      owner: {
        address: '',
        driverId: '',
        isOwner: 1,
        idcard: '',
        name: '',
        phone: ''
      },
      driver: {
        driverId: '',
        isOwner: 0,
        name: '',
        phone: ''
      },
      receiptOrderRules: {
        actualFreight: [
          {required: true, message: '实际运费不能为空', trigger: 'blur'}
        ],
        tonnage: [
          {required: true, message: '吨位不能为空', trigger: 'blur'}
        ],
        total: [
          {validator: validateTotal, required: true, trigger: 'blur'}
        ],
        cash: [
          {validator: validateMoney, required: true, trigger: 'blur'}
        ],
        weixin: [
          {validator: validateMoney, required: true, trigger: 'blur'}
        ],
        advances: [
          {validator: validateMoney, required: true, trigger: 'blur'}
        ],
        carPhone: [
          {pattern: /^0?1[3|4|5|6|9|8|7][0-9]\d{8}$/, message: '订车电话格式不正确', trigger: ['blur', 'change']}
        ],
        ownerPhone: [
          {pattern: /^0?1[3|4|5|6|9|8|7][0-9]\d{8}$/, message: '车主电话格式不正确', trigger: ['blur', 'change']},
          {required: true, message: '车主电话不能为空', trigger: 'blur'}
        ],
        ownerName: [
          {required: true, message: '车主姓名不能为空', trigger: 'blur'}
        ],
        carNumber: [
          {required: true, message: '车牌号码不能为空', trigger: 'blur'},
          {
            pattern: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/,
            message: '车牌号码格式不正确',
            trigger: ['blur', 'change']
          }
        ],
        IDCard: [
          {pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/, message: '身份证号不正确', trigger: ['blur']}
        ]
      },
      show: false
    }
  },
  computed: {
    money () {
      let advice = (this.receiptOrderForm.actualFreight * 1 - this.receiptOrderForm.freight * 1) * this.receiptOrderForm.tonnage
      if (isNaN(advice)) {
        return 0
      } else {
        return Math.round(advice)
      }
    },
    avoid () {
      let advice = (this.receiptOrderForm.total * 1 - this.receiptOrderForm.cash * 1 - this.receiptOrderForm.weixin * 1 - this.money)
      if (isNaN(advice)) {
        return 0
      } else {
        return Math.round(Math.abs(advice))
      }
    }
  },
  created () {
  },
  watch: {
    fold (val) {
      this.show = val
      if (val) {
        // tab键跳过input
        let tab = document.getElementsByClassName('tabindex')
        for (let i = 0; i < tab.length; i++) {
          tab[i].firstChild.lastChild.setAttribute('tabindex', '-1')
        }
        // end
        this.reset()
        this.$refs.receiptOrderForm.resetFields()
        this.$nextTick(function () {
          setTimeout(() => {
            this.$refs['freight'].focus()
          }, 700)
          // 根据车牌号码查询车牌及车主信息
          if (!this.wei.isNull(this.receiptOrder.carNumber) && this.wei.isNull(this.receiptOrder.carId)) {
            // 开配货单
            selectCar(this.receiptOrder.carNumber, this.receiptOrder.appId).then((response) => {
              let carVo = response.data.data
              this.receiptOrderForm.carId = carVo.carId
              this.receiptOrderForm.carNumber = carVo.carNumber
              if (!this.wei.isNull(carVo.driverId)) {
                this.receiptOrderForm.ownerId = carVo.driverId
                this.receiptOrderForm.ownerName = carVo.name
                this.receiptOrderForm.ownerPhone = carVo.phone
                this.receiptOrderForm.address = carVo.address
                this.receiptOrderForm.IDCard = carVo.idcard
              }
            })
          } else if (!this.wei.isNull(this.receiptOrderForm.receiptId)) {
            // 修改配货单
            this.receiptOrderForm.carNumber = this.receiptOrder.carNumber
            this.receiptOrderForm.ownerId = this.receiptOrder.ownerId
            this.receiptOrderForm.ownerName = this.receiptOrder.ownerName
            this.receiptOrderForm.ownerPhone = this.receiptOrder.ownerPhone
            this.receiptOrderForm.address = this.receiptOrder.address
            this.receiptOrderForm.IDCard = this.receiptOrder.idcard
            this.receiptOrderForm.carId = this.receiptOrder.carId
            if (!this.wei.isNull(this.receiptOrder.driverId)) {
              this.receiptOrderForm.driverId = this.receiptOrder.driverId
              this.receiptOrderForm.carName = this.receiptOrder.driverName
              this.receiptOrderForm.carPhone = this.receiptOrder.driverPhone
            }
          }
          // 根据上车电话查询车主信息
          if (!this.wei.isNull(this.receiptOrder.carPhone)) {
            selectDriver(this.receiptOrder.carPhone).then((response) => {
              let driver = response.data.data
              this.receiptOrderForm.ownerId = driver.driverId
              this.receiptOrderForm.ownerName = driver.name
              this.receiptOrderForm.ownerPhone = driver.phone
              this.receiptOrderForm.address = driver.address
              this.receiptOrderForm.IDCard = driver.idcard
            })
          }
        })
      }
    },
    receiptOrder: {
      handler: function (val) {
        this.$refs.receiptOrderForm.resetFields()
        this.receiptOrderForm.actualFreight = val.actualFreight
        this.receiptOrderForm.createDate = val.createDate
        this.receiptOrderForm.address = val.address
        this.receiptOrderForm.createBy = val.userId * 1
        // this.receiptOrderForm.carPhone = val.driverPhone
        this.receiptOrderForm.advances = val.advances
        this.receiptOrderForm.cash = val.cash
        this.receiptOrderForm.tonnage = val.tonnage
        this.receiptOrderForm.total = val.total
        this.receiptOrderForm.weixin = 0
        this.receiptOrderForm.receiptId = val.receiptId
        this.receiptOrderForm.freight = val.freight
        this.receiptOrderForm.areaName = val.areaName
        this.receiptOrderForm.areaCode = val.areaCode
        this.receiptOrderForm.orderId = val.orderId
        this.receiptOrderForm.supplyId = val.supplyId
        this.receiptOrderForm.appId = val.appId
        this.receiptOrderForm.remark = val.remark
        this.receiptOrderForm.priceUnit = val.priceUnit
        // this.receiptOrderForm.carNumber = val.carNumber
        // this.receiptOrderForm.ownerPhone = val.carPhone
      }
    }
  },
  methods: {
    handleCheckCarNumber (i) {
      this.carNumberIsEnable = i
      if (i) {
        this.receiptOrderForm.carId = 1022
        this.receiptOrderForm.carNumber = '辽N00000'
      } else {
        this.receiptOrderForm.carId = ''
        this.receiptOrderForm.carNumber = ''
      }
    },
    handleCheckOwnPhone (i) {
      this.ownPhoneIsEnable = i
      if (i) {
        this.receiptOrderForm.ownerPhone = '15000000000'
        this.receiptOrderForm.ownerId = 1442
      } else {
        this.receiptOrderForm.ownerPhone = ''
        this.receiptOrderForm.ownerId = ''
      }
    },
    handleCheckOwnName (i) {
      this.ownNameIsEnable = i
      if (i) {
        this.receiptOrderForm.ownerName = '不明'
      } else {
        this.receiptOrderForm.ownerName = ''
      }
    },
    handleCheckDriverPhone (i) {
      this.driverPhoneIsEnable = i
      if (i) {
        this.receiptOrderForm.carPhone = '15000000000'
        this.receiptOrderForm.driverId = 1442
      } else {
        this.receiptOrderForm.carPhone = ''
        this.receiptOrderForm.driverId = ''
      }
    },
    handleCheckDriverName (i) {
      this.driverNameIsEnable = i
      if (i) {
        this.receiptOrderForm.carName = '不明'
      } else {
        this.receiptOrderForm.carName = ''
      }
    },
    reset () {
      this.ownNameIsEnable = false
      this.carNumberIsEnable = false
      this.ownPhoneIsEnable = false
      this.driverPhoneIsEnable = false
      this.driverNameIsEnable = false
    },
    blurCarNumber () {
      if (this.receiptOrderForm.carNumber.length === 7) {
        selectCar(this.receiptOrderForm.carNumber, this.receiptOrderForm.appId).then((response) => {
          let carVo = response.data.data
          this.receiptOrderForm.carNumber = carVo.carNumber
          this.receiptOrderForm.carId = carVo.carId
        })
      }
    },
    blurDriverPhone () {
      if (this.receiptOrderForm.carPhone.length === 11) {
        selectDriver(this.receiptOrderForm.carPhone).then((response) => {
          let driver = response.data.data
          this.receiptOrderForm.carPhone = driver.phone
          this.receiptOrderForm.driverId = driver.driverId
          this.driver.driverId = driver.driverId
          this.driver.phone = driver.phone
        })
      }
    },
    blurOwnerPhone () {
      if (this.receiptOrderForm.ownerPhone.length === 11) {
        selectDriver(this.receiptOrderForm.ownerPhone).then((response) => {
          let driver = response.data.data
          this.receiptOrderForm.ownerPhone = driver.phone
          this.receiptOrderForm.ownerId = driver.driverId
          this.owner.phone = driver.phone
          this.owner.driverId = driver.driverId
        })
      }
    },
    queryOwner (queryString, cb) {
      this.receiptOrderForm.ownerId = ''
      getDriverForPhone(queryString).then((response) => {
        if (response.data.data.records.length > 0) {
          cb(response.data.data.records)
        } else {
          // eslint-disable-next-line
          cb([{
            phone: queryString,
            name: '',
            title: '这是新的电话号码，请点击新增',
            empty: true,
            driverId: ''
          }])
        }
      })
    },
    queryDriver (queryString, cb) {
      this.receiptOrderForm.driverId = ''
      getDriverForPhone(queryString).then((response) => {
        if (response.data.data.records.length > 0) {
          cb(response.data.data.records)
        } else {
          // eslint-disable-next-line
          cb([{
            phone: queryString,
            name: '',
            title: '这是新的电话号码，请点击新增',
            empty: true,
            driverId: ''
          }])
        }
      })
    },
    handleSelectDriver (item) {
      if (item.empty) {
        selectDriver(item.phone).then((response) => {
          let driver = response.data.data
          this.receiptOrderForm.carPhone = driver.phone
          this.receiptOrderForm.driverId = driver.driverId
          this.driver.driverId = driver.driverId
          this.driver.phone = driver.phone
        })
      } else {
        this.receiptOrderForm.driverId = item.driverId
        this.receiptOrderForm.carName = item.name
        this.receiptOrderForm.carPhone = item.phone
        this.driver.driverId = item.driverId
        this.driver.phone = item.phone
        this.driver.name = item.name
      }
    },
    handleSelectOwner (item) {
      if (item.empty) {
        selectDriver(item.phone).then((response) => {
          let driver = response.data.data
          this.receiptOrderForm.ownerPhone = driver.phone
          this.receiptOrderForm.ownerId = driver.driverId
          this.owner.phone = driver.phone
          this.owner.driverId = driver.driverId
        })
      } else {
        this.receiptOrderForm.ownerId = item.driverId
        this.receiptOrderForm.address = item.address
        this.receiptOrderForm.IDCard = item.idcard
        this.receiptOrderForm.ownerName = item.name
        this.receiptOrderForm.ownerPhone = item.phone
        this.owner.address = item.address
        this.owner.driverId = item.driverId
        this.owner.idcard = item.idcard
        this.owner.name = item.name
        this.owner.phone = item.phone
      }
    },
    queryCar (queryString, cb) {
      let _this = this
      _this.receiptOrderForm.carId = ''
      getCarForNumber(queryString, _this.receiptOrder.appId).then((response) => {
        if (response.data.data.records.length > 0) {
          cb(response.data.data.records)
        } else {
          // eslint-disable-next-line
          cb([{
            carNumber: queryString,
            name: '',
            title: '这是新的车牌号码，请点击新增',
            empty: true,
            phone: '',
            driverId: '',
            address: '',
            carId: ''
          }])
        }
      })
    },
    handleSelectCar (item) {
      if (item.empty) {
        selectCar(item.carNumber, this.receiptOrder.appId).then((response) => {
          let carVo = response.data.data
          this.receiptOrderForm.carNumber = carVo.carNumber
          this.receiptOrderForm.carId = carVo.carId
        })
      } else {
        if (item.driverId !== null) {
          this.receiptOrderForm.ownerId = item.driverId
          this.receiptOrderForm.address = item.address
          this.receiptOrderForm.IDCard = item.idcard
          this.receiptOrderForm.ownerName = item.name
          this.receiptOrderForm.ownerPhone = item.phone
        }
        this.receiptOrderForm.carId = item.carId
        this.receiptOrderForm.carNumber = item.carNumber
      }
    },
    submitForm (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.receiptOrderForm.freight = this.receiptOrderForm.actualFreight
          if (!this.wei.isNull(this.receiptOrderForm.driverId)) {
            this.driver.phone = this.receiptOrderForm.carPhone
            this.driver.name = this.receiptOrderForm.carName
            this.driver.address = this.receiptOrderForm.address
            updateDriver(this.receiptOrderForm.driverId, this.driver).then()
          }
          this.owner.address = this.receiptOrderForm.address
          this.owner.driverId = this.receiptOrderForm.ownerId
          this.owner.idcard = this.receiptOrderForm.IDCard
          this.owner.name = this.receiptOrderForm.ownerName
          this.owner.phone = this.receiptOrderForm.ownerPhone
          updateDriver(this.receiptOrderForm.ownerId, this.owner).then()
          if (this.receiptOrderForm.receiptId != null) {
            if (this.receiptOrderForm.createBy === this.receiptOrder.userId) {
              this.receiptOrderForm.createBy = 0
            }
            updateReceiptOrder(this.receiptOrderForm.receiptId, this.receiptOrderForm).then((response) => {
              _this.hideList(response.data.data.receiptId)
            }).catch(() => {
              _this.hideList('receiptOrderForm')
            })
          } else {
            createReceiptOrder(this.receiptOrderForm).then((response) => {
              _this.$router.push({path: './receiptList', query: {receiptId: response.data.data.receiptId}})
            }).catch(() => {
              _this.hideList('receiptOrderForm')
            })
          }
        } else {
          return false
        }
      })
    },
    hideList (receiptId) {
      this.show = false
      this.$emit('hiden', receiptId)
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .receiptOrder
    position fixed
    right 0
    top 70px
    z-index 50
    width 540px
    height 99%
    background #fff
    transform: translate3d(0, 0, 0)
    &.fold-enter-active, &.fold-leave-active
      transition: all 0.3s
    &.fold-enter, &.fold-leave-active
      transform: translate3d(500px, 0, 0)
    .head
      height: 40px;
      line-height: 40px;
      padding: 0 18px;
      background: #f3f5f7;
      border-bottom: 1px solid rgba(7,17,27,0.1);
    .content
      padding-top 10px
      padding-left 10px
      padding-right 29px
    .foot
      button
       width 100%
  .list-mask
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: 40
    backdrop-filter: blur(3px)
    opacity: 1
    background: rgba(7, 17, 27, 0.6)
    &.fade-enter-active, &.fade-leave-active
      transition: background  0.3s
    &.fade-enter, &.fade-leave-active
      opacity: 0
      background: rgba(7, 17, 27, 0)
</style>
